import React, { useEffect, useState } from 'react';
import './HeroSection.css';
import { useTranslation } from 'react-i18next';

const HeroSection = ({ isMenuOpen }) => {
  const { t, i18n } = useTranslation();

  const images = [
    '/images/hero_3.png',
    '/images/hero_1.png',
    '/images/hero_2.png',
    '/images/hero_4.png',
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 7500);

    return () => clearInterval(interval);
  }, [images.length]);

  const currentLanguage = i18n.language || 'en';

  return (
    <div className={`hero-container ${currentLanguage}`}>
      <div className={`hero-section ${isMenuOpen ? 'hero-section-menu-open' : ''}`}>
        <div className="hero-section-text">
          <div className="hero-section-text-heading">
            <h1 className="line-1">{t('homeHeading1')}</h1>
            <h1 className="line-2">{t('homeHeading2')}</h1>
          </div>
          <div className="hero-section-text-body">
            <p>{t('homeDescription')}</p>
          </div>
        </div>
        <div className="hero-section-image">
          <div className="hero-section-background"></div>
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Hero ${index + 1}`}
              className={index === currentImageIndex ? 'carousel-image active' : 'carousel-image'}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
